<style lang="scss" type="text/scss" scoped>
@import "./scss/ProfitTable.scss";
</style>

<template>
  <div class="dataTables_wrapper no-footer mtable">
    <el-dialog :title="multiLanguage.dialog_title" width="15%" :visible.sync="visible">
      <el-date-picker
        v-model="timePicker"
        type="date"
        :placeholder="multiLanguage.date_placeholder"
        value-format="yyyy-MM-dd 00:00:00"
        :picker-options="pickerOption"
      ></el-date-picker>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{multiLanguage.cancel}}</el-button>
        <el-button type="primary" @click="confirmDateHandle">{{multiLanguage.ensure}}</el-button>
      </div>
    </el-dialog>
    <slot name="menu"></slot>
    <div class="datatable-header mtable-tool hui-group-dib-box">
      <selPage
        v-if="selPage"
        class="pull-right"
        :multiLanguage="multiLanguage"
        :selPage="selPage"
        @selPage="selPageFn"
      ></selPage>
      <div class="btn-group p-0 pull-left mtable-tool-fn">
        <slot name="return-back"></slot>
        <slot name="handle"></slot>
        <div v-if="operate" class="commission-confirm">
          <el-button-group v-if="operate.btnGroup">
            <el-button
              type="primary"
              v-if="doConfirm"
              :disabled="!undoConfirm || !threeConfirm"
              @click="confirmHandle(operate.updateVal.do)"
            >{{multiLanguage.do}}</el-button>
            <el-button
              type="success"
              v-else
              :disabled="!undoConfirm"
              @click="confirmHandle(operate.updateVal.do)"
            >{{multiLanguage.doConfirm}}</el-button>
            <el-button
              type="primary"
              v-if="undoConfirm"
              :disabled="!doConfirm || !threeConfirm"
              @click="confirmHandle(operate.updateVal.undo)"
            >{{multiLanguage.undo}}</el-button>
            <el-button
              type="success"
              v-else
              :disabled="!doConfirm"
              @click="confirmHandle(operate.updateVal.undo)"
            >{{multiLanguage.undoConfirm}}</el-button>
            <el-button
              type="primary"
              v-if="threeConfirm"
              :disabled="!doConfirm || !undoConfirm"
              @click="confirmHandle(operate.updateVal.three)"
            >{{multiLanguage.three}}</el-button>
            <el-button
              type="success"
              v-else
              :disabled="!doConfirm || !undoConfirm"
              @click="confirmHandle(operate.updateVal.three)"
            >{{multiLanguage.threeConfirm}}</el-button>
          </el-button-group>
          <el-button
            v-if="operate.btn"
            type="primary"
            :disabled="checkedArr.length == 0"
            @click="updateStatus"
          >{{multiLanguage.btn}}</el-button>
        </div>

        <jsonExcel
          v-if="jsonExcelAjax"
          class="btn btn-default"
          :ajaxUrl="jsonExcelAjax.url || false"
          :ajaxPar="jsonExcelAjax.ajaxPar || false"
          :ajaxType="jsonExcelAjax.ajaxType"
          :rID="jsonExcelAjax.rID"
          :cID="jsonExcelAjax.cID"
          :type="jsonExcelAjax.type"
          :keys="thData"
          :ajaxGetKey="jsonExcelAjax.getKey"
          :downLoadTran="downLoadTran"
          :name="name"
        >
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{multiLanguage.downloadExcelForms}}
        </jsonExcel>

        <jsonExcel
          v-if="detailExcelAjax"
          class="btn btn-default"
          :ajaxUrl="detailExcelAjax.url || false"
          :ajaxPar="detailExcelAjax.ajaxPar || false"
          :ajaxType="detailExcelAjax.ajaxType"
          :rID="detailExcelAjax.rID"
          :keys="detailTh"
          :ajaxGetKey="detailExcelAjax.getKey"
          :downLoadTran="downLoadTran"
          :name="detailName"
        >
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{multiLanguage.downloadDetailExcel}}
        </jsonExcel>

        <multi-sheet-excel
          v-if="multiExcelAjax"
          class="btn btn-default"
          :ajaxUrl="multiExcelAjax.url || false"
          :ajaxPar="multiExcelAjax.ajaxPar || false"
          :ajaxType="multiExcelAjax.ajaxType"
          :firstTh="firstTh"
          :secondTh="secondTh"
          :rID="multiExcelAjax.rID"
          :sheetName="multiLanguage.sheetName"
          :downloadName="multiLanguage.downloadName"
          :ajaxGetKey="multiExcelAjax.getKey"
          :dataTh="multiExcelAjax.dataTh"
        >
          <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
          {{multiLanguage.downloadDetailExcel}}
        </multi-sheet-excel>
      </div>
      <div class="clear"></div>
    </div>
    <div class="datatable-scroll" style="overflow: auto;">
      <slot name="datatable-scroll"></slot>
      <slot name="title-name"></slot>
      <table
        class="table table-striped table-bordered table-hover datatable-highlight dataTable no-footer"
        id="DataTables_Table_2"
        role="grid"
        aria-describedby="DataTables_Table_2_info"
      >
        <thead>
          <tr role="row">
            <th v-if="operate">
              <el-checkbox
                v-if="selectData.length !== 0"
                :indeterminate="isIndeterminate"
                v-model="selectAll"
                @change="checkAll"
              ></el-checkbox>
            </th>
            <th
              v-for="(item,index) in thData"
              v-if="item.flag === undefined ? true: item.flag"
            >{{item.name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr role="row" v-show="trData.length > 0" v-for="(item,index) in trData">
            <td v-if="operate">
              <input
                type="checkbox"
                v-if="item.show"
                v-model="item.checked"
                @change="updateCheckArr(item)"
              />
              <!-- <el-checkbox v-if="item.show" v-model="item.checked" @change="updateCheckArr(item)"></el-checkbox> -->
            </td>
            <td v-for="obj in thData" v-if="obj.flag === undefined ? true: obj.flag">
              <a
                v-if="link && link.key.indexOf(obj.key) > -1"
                @click="linkDetails(item)"
              >{{item[obj.key]}}</a>
              <span v-else-if="tip && tip.key.indexOf(obj.key) > -1">
                <el-tooltip>
                  <div slot="content">
                    <span v-for="(tips,value) in JSON.parse(item[obj.key])">
                      {{value}}&nbsp;&nbsp;:&nbsp;&nbsp;{{tips}}
                      <br />
                    </span>
                  </div>
                  <span
                    v-if="item[obj.key] && item[obj.key].length > 40"
                  >{{item[obj.key].substr(0, 40) + '...'}}</span>
                  <span v-else>{{item[obj.key]}}</span>
                </el-tooltip>
              </span>
              <span v-else>{{item[obj.key]}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <noData v-if="trData.length==0" :text="multiLanguage.nodata" :fontSize="'18'"></noData>
    </div>
    <div class="datatable-footer" v-if="selPage">
      <div
        class="dataTables_info"
        id="DataTables_Table_2_info"
        role="status"
        aria-live="polite"
      >{{multiLanguage.clauses}}{{multiLanguage.amount}}:&nbsp;{{page.pageLeng}}&nbsp;&nbsp;{{multiLanguage.present}}:&nbsp;{{page.active*selPage.limit-selPage.limit+1}}-{{Math.min(page.active*selPage.limit,page.pageLeng)}}</div>
      <div
        v-if="Math.ceil(page.pageLeng/selPage.list[selPage.active])"
        class="dataTables_paginate paging_simple_numbers"
        id="DataTables_Table_2_paginate"
      >
        <pagination
          v-model="page.active"
          :boundary-links="true"
          :direction-links="true"
          :total-page="Math.ceil(page.pageLeng/selPage.list[selPage.active])"
          :max-size="page.pagenum"
          @change="callpageFn"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import selPage from "components/selPage";
import noData from "components/noData";
import { Dropdown, Pagination } from "uiv";
import jsonExcel from "./comm/excel";
import multiSheetExcel from "../CommissionSetting/comm/multiSheetExcel";
import { mapMutations } from "vuex";

export default {
  props: {
    thData: {
      // 表格th数据
      type: Array,
      default: []
    },
    firstTh: {
      type: Object,
      default: () => {}
    },
    secondTh: {
      type: Object,
      default: () => {}
    },
    detailTh: {
      type: Array,
      default: () => []
    },
    trData: {
      type: Array,
      default: () => []
    },
    operate: {
      default: false
    },
    link: {
      default: false
    },
    tip: {
      default: false
    },
    multiLanguage: {
      // 翻译，也是文字型数据
      type: Object,
      default: {}
    },
    selPage: {
      // 显示条目数
      default: false
    },
    page: {
      // 分页
      default: false
    },
    jsonExcelAjax: {
      // 下载Excel
      default: false
    },
    name: {
      default: ""
    },
    detailName: {
      defalut: ""
    },
    detailExcelAjax: {
      default: false
    },
    multiExcelAjax: {
      default: false
    },
    back: {
      type: String,
      default: () => ""
    },
    downLoadTran: {
      type: Object,
      default: () => {}
    },
    curArea: {
      defalut: ""
    }
  },
  data() {
    return {
      checkedArr: [],
      isIndeterminate: false,
      selectAll: false,
      trSize: 0,
      selectData: [],
      mapObj: {},
      doConfirm: true,
      undoConfirm: true,
      threeConfirm: true,
      visible: false,
      timePicker: "",
      pickerOption: {
        disabledDate: () => {}
      }
    };
  },
  mounted() {
    if (this.selPage && !this.selPage.active) this.$parent.selPage.active = 0;
    const obj = this.operate.updateVal;
    if (obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) this.mapObj[obj[key]] = key + "Confirm";
      }
    }
  },
  methods: {
    confirmHandle(value) {
      if (this.checkedArr.length > 0) {
        if (value == 0) this.visible = true;
        if (value == 1) this.updateStatus(value);
        if (value == 2) this.dateHandle();
        return;
      }
      const show = this.operate.showKey[value];
      const key = this.mapObj[value];
      this[key] = !this[key];
      this.trData.forEach(val => {
        if (this[key]) val.show = false;
        else val.show = val[show[0]] == show[1];
        if (val.show) {
          this.trSize++;
          this.selectData.push(val);
        }
      });
      if (this.doConfirm && this.undoConfirm && this.threeConfirm) {
        this.trSize = 0;
        this.selectData = [];
      }
    },
    confirmDateHandle() {
      if (!this.timePicker) {
        this.$message({
          message: this.multiLanguage.required,
          type: "warning"
        });
        return;
      }
      const updateVal = this.$moment(this.timePicker).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.undoConfirm
        ? this.updateStatus(updateVal)
        : this.updateStatus(0, updateVal);
    },
    dateHandle() {
      this.visible = true;
      let validTime = { start: "1970-01-01", end: "" };
      const yesterday = this.$moment().subtract(1, "d");
      const eightYesterday = yesterday.format("YYYY-MM-DD") + " 08:00:00";
      const passEight = yesterday.isAfter(eightYesterday);
      validTime.end = passEight
        ? yesterday.format("YYYY-MM-DD")
        : yesterday.subtract(1, "d").format("YYYY-MM-DD");
      this.checkedArr.forEach(v => {
        const endDate = v.LAST_CALC_END_DATE || v.APPLICATION_DATE;
        const dateMoment = this.$moment(endDate);
        if (!dateMoment.isAfter(validTime.start)) return;
        validTime.start = v.LAST_CALC_END_DATE
          ? dateMoment.format("YYYY-MM-DD")
          : dateMoment.subtract(1, "d").format("YYYY-MM-DD");
      });
      this.pickerOption.disabledDate = function(time) {
        return (
          time.getTime() > new Date(validTime.end) ||
          time.getTime() < new Date(validTime.start)
        );
      };
    },
    updateStatus(value, options) {
      if (window.confirm(this.multiLanguage.commit)) {
        let ajaxObj = { area: this.curArea, data: this.checkedArr };

        const updateMap = this.operate.updateKey;
        if (updateMap) {
          // 找不到需要更新的字段，则使用备用的字段
          const updateKey = updateMap[value] || updateMap.backup;
          ajaxObj.update_key = updateKey;
          ajaxObj.value = value;
          ajaxObj.update_by = JSON.parse(
            sessionStorage.getItem("user")
          ).user_name;
        }

        if (options) ajaxObj.bind_date = options;

        this.checkedArr = [];
        this.$http.post(this.operate.url, ajaxObj).then(res => {
          this.trSize = 0;
          this.selectData = [];
          this.isIndeterminate = false;
          this.visible = false;
          const key = this.mapObj[value] || "threeConfirm";
          this[key] = !this[key];
          this.$emit("tableChange");
        });
      } else return false;
    },
    checkAll(val) {
      this.checkedArr = val ? this.selectData.slice() : [];
      for (let v of this.trData) v.checked = val;
      //console.log(this.checkedArr.length)
      this.isIndeterminate = false;
    },
    updateCheckArr(checkObj) {
      if (this.checkedArr.indexOf(checkObj) > -1)
        this.checkedArr.splice(this.checkedArr.indexOf(checkObj), 1);
      else this.checkedArr.push(checkObj);
      this.selectAll = this.checkedArr.length === this.trSize;
      this.isIndeterminate =
        this.checkedArr.length > 0 && this.checkedArr.length < this.trSize;
    },
    selPageFn(index, item) {
      this.SAVEPAGEMAXINDEX(index);
      this.$parent.selPage.active = index;
      this.$parent.selPage.limit = this.selPage.list[this.selPage.active];
      this.$parent.page.offset = 0;
      this.pageactive = 1;
      this.$parent.page.active = 1;
      this.$emit("tableChange");
    },
    callpageFn(index) {
      this.$parent.page.active = index;
      this.$parent.page.offset = this.selPage
        ? (this.page.active - 1) * this.selPage.list[this.selPage.active]
        : "";
      this.$emit("tableChange");
    },
    linkDetails(item) {
      if (this.back !== "") {
        sessionStorage.setItem("back", this.back);
      }
      this.$router.push({
        path: this.link.path,
        query: item
      });
    },
    ...mapMutations(["SAVEPAGEMAXINDEX"])
  },
  watch: {
    trData(newVal, oldVal) {
      this.selectAll = false;
      this.isIndeterminate = false;
      this.trSize = 0;
      this.selectData = [];
      this.checkedArr = [];
      const show = this.operate.showKey;
      if (this.operate) {
        newVal.forEach(v => {
          if (this.operate.btnGroup) {
            if (this.doConfirm && this.undoConfirm && this.threeConfirm)
              v.show = false;
            else
              v.show =
                this.doConfirm && this.threeConfirm
                  ? v[show[0][0]] == show[0][1]
                  : v[show[1][0]] == show[1][1];
          }
          if (this.operate.btn) {
            for (const condition of show)
              if (v[condition.key] == condition.value) v.show = true;
          }
          if (v.show) {
            this.trSize++;
            this.selectData.push(v);
          }
        });
      }
    }
  },
  components: {
    selPage,
    Dropdown,
    Pagination,
    jsonExcel,
    multiSheetExcel,
    noData
  }
};
</script>



// WEBPACK FOOTER //
// ProfitTable.vue?757bfbeb